module.exports = __webpack_public_path__ + "resources/img/head-logo.eac5abc2.png";